import Button from '@betterfunnel/ui-core/Button';
import { PlusIcon } from '@heroicons/react/24/outline';
import * as Sentry from '@sentry/react';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import facebookAdsIcon from '../assets/images/facebookAdsIcon.png';
import { UserContext } from '../contexts/UserContext';
import ConnectAdsAccountsModal from '../modals/ConnectAdsAccountsModal';
import { track } from '../utils/analytics';
import { DEFAULT_FACEBOOK_ADS_SCOPES, getFacebookUrl } from '../utils/auth';

export default function ConnectFacebookAds() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { createOAuthRequest } = useContext(UserContext);

  const [connectAccountsModalOpen, setConnectAccountsModalOpen] =
    useState<string>();

  useEffect(() => {
    const facebookAdsRequestId = searchParams.get('facebookAdsRequestId');
    if (!facebookAdsRequestId) return;

    setConnectAccountsModalOpen(facebookAdsRequestId);
  }, [searchParams]);

  const handleClick = useCallback(async () => {
    track('connect_facebook_ads_button_click');

    try {
      const from = location.pathname;
      const state = await createOAuthRequest(
        'facebook',
        from,
        DEFAULT_FACEBOOK_ADS_SCOPES,
      );

      window.location.replace(
        getFacebookUrl(from, state, DEFAULT_FACEBOOK_ADS_SCOPES),
      );
    } catch (e) {
      Sentry.captureException(e);
      console.error(e);
    }
  }, [createOAuthRequest, location.pathname]);

  return (
    <>
      <ConnectAdsAccountsModal
        requestId={connectAccountsModalOpen || ''}
        provider="facebook"
        open={!!connectAccountsModalOpen}
        onClose={() => {
          setSearchParams(new URLSearchParams());
          setConnectAccountsModalOpen(undefined);
        }}
      />
      <div className="flex max-w-xs flex-col items-center text-center">
        <img src={facebookAdsIcon} width={62} />
        <h3 className="mt-2 text-sm font-semibold text-gray-900">
          Connect your Facebook Ads account
        </h3>
        <p className="mt-2 text-sm text-gray-500">
          By connecting your ad account we can fully integrate your ads with
          amazing dynamic landing pages
        </p>
        <div className="mt-6">
          <Button size="large" onClick={handleClick}>
            <PlusIcon className="h-5 w-5" aria-hidden="true" />
            Connect
          </Button>
        </div>
      </div>
    </>
  );
}
